import React, {Component} from "react";
import styles from './detailBloodStationNotice.module.scss';
import {inject, observer} from "mobx-react";
import BloodStationStore from "../../../stores/BloodStationStore";

@inject('bloodStationsStore')
@observer
export default class DetailBloodStationNotice extends Component<any, any> {
  props: {
    id: string | number;
    bloodStationsStore?: BloodStationStore;
    changeNoticeShow: (state: boolean) => void;
  }

  state: {
    notices: any[];
  }

  constructor(props) {
    super(props);
    this.state = {
      notices: null
    }
  }


  componentDidMount() {
    this.props.bloodStationsStore.getNoticeFromBSID(this.props.id)
      .then(r => {
        if (r.results.length === 0) {
          this.props.changeNoticeShow(false)
          return
        }
        this.setState({
          notices: r.results
        })
      })
  }

  render() {
    const {state} = this;
    const {notices} = state;
    return (
      <div className={styles.DetailBloodStationNotice}>
        {notices && notices.map(notice => <NoticeCard key={notice.id} notice={notice}/>)}
      </div>
    )
  }
}

class NoticeCard extends Component<any, any> {
  props: {
    notice: any;
  }
  state: {
    isMoreOpened: boolean;
  }

  constructor(props) {
    super(props);
    this.state = {
      isMoreOpened: false
    }
  }

  openMore = () => {
    this.setState({
      isMoreOpened: !this.state.isMoreOpened
    })
  }


  render() {
    const {props, state, openMore} = this;
    const {notice} = props;
    const {isMoreOpened} = state;
    const {title, text} = notice;
    const isButtonNeed = text.length > 180;
    return (
      <div className={styles.NoticeCard}>
        <div className={styles.NoticeCard_Title}>
          <h3>{title}</h3>
        </div>
        <div className={isMoreOpened ? styles.NoticeCard_BodyOpen : styles.NoticeCard_Body}
             dangerouslySetInnerHTML={{__html: text}}/>
        {isButtonNeed && !isMoreOpened && <span
            onClick={openMore}
            className={styles.NoticeCard_Body_More}>Подробнее</span>}
      </div>
    )
  }
}
